export default __webpack_public_path__ + "static/media/line.f0f1b8cc.svg";